<template>
  <div id="container">22</div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style scoped lang="scss">
#container {
  /* width: 100vw; */
  /* height: 100vh; */
  position: relative;
  .popup {
    position: absolute;
    top: 100px;
    left: 100px;
    width: 300px;
    height: 200px;
    border: 1px solid darkcyan;
    background: #eee;
  }
}
</style>